module.exports = __webpack_public_path__ + "341a5a0931a87324a0d12099cf500170.MP3";